import Vue from 'vue'
import App from './App.vue'
import router from './router'

// https://github.com/dsktschy/viewport-extra
import ViewportExtra from 'viewport-extra'
new ViewportExtra(414)

// https://github.com/hilongjw/vue-lazyload
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 3
})

import './assets/styles/index.scss'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
